<template>
  <b-card-code title="All questions " no-body name="Add question">
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <validation-observer ref="questionInfoRules" tag="form">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">question Details</h5>
            <small class="text-muted"> Enter the question Details. </small>
          </b-col>
          <b-col md="6">
            <b-form-group label="title" label-for="name">
              <validation-provider
                #default="{ errors }"
                name="title"
                rules="required|min:3"
              >
                <b-form-input
                  id="title"
                  v-model="question.title"
                  :state="errors.length > 0 ? false : null"
                  placeholder="question title"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="question type" label-for="questiontype">
              <validation-provider
                #default="{ errors }"
                name="question type"
                rules="required"
              >
                <b-form-select
                  id="questiontype"
                  :state="errors.length > 0 ? false : null"
                  v-model="question.type"
                  :options="options"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="grad" label-for="grad">
              <validation-provider
                #default="{ errors }"
                name="grad"
                rules="required|numeric"
              >
                <b-form-input
                  id="title"
                  v-model="question.grad"
                  :state="errors.length > 0 ? false : null"
                  placeholder="question title"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="question Cover Image"
              label-for="CorseCoverImage"
            >
              <validation-provider #default="{ errors }" name="CorseCoverImage">
                <b-form-file
                  id="CorseCoverImage"
                  accept="image/*"
                  v-model="question.imageCover"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="hint" label-for="hint">
              <validation-provider #default="{ errors }" name="hint">
                <b-form-textarea
                  id="hint"
                  placeholder="hint"
                  v-model="question.hint"
                  :state="errors.length > 0 ? false : null"
                  rows="5"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <addAnswerSection :answers="question.answers" />
          </b-col>
          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mt-0 mt-md-2 w-100"
              @click="handleOk()"
            >
              <feather-icon icon="PlusIcon" class="mr-25" />
              <span>Add The Question</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </form>
  </b-card-code>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import questionsApi from "@/apiServices/questionsApi";
import { required, email, max_value, numeric } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import addAnswerSection from "@/views/answers pages/components/add answers section.vue";
import imagesApi from "@/apiServices/imagesApi";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    addAnswerSection,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    required,
    email,
    max_value,
    numeric,
    name: "",
    nameState: null,
    options: ["single_choice", "multi_choice", "true_false"],
    submittedNames: [],
    question: {
      title: "",
      description: "",
      type: "",
      imageCover: null,
      answers: [],
      grad: 0,
    },
  }),
  methods: {
    createquestions(questionFormData) {
      questionsApi.createquestion(questionFormData).then((response) => {
        if (response.data) {
          this.question = response.data;
          console.log(response.data);
          this.$toast({
            component: ToastificationContent,
            props: {
              title:
                "question Created complite adding the sections and questions",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
    },

    createquestionValidation() {
      return new Promise((resolve, reject) => {
        this.$refs.questionInfoRules.validate().then((success) => {
          if (success) {
            const questionFormData = new FormData();
            // this.question.answers.forEach((item) => {
            //   item = item._id;
            // });
            this.question.answers = this.question.answers.map((a) => a._id);

            this.createquestions(this.question);

            // this.question = {};
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    resetModal() {
      this.name = "";
      this.nameState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      if (this.question.imageCover instanceof File) {
        const imageFormData = new FormData();
        imageFormData.append("image", this.question.imageCover);
        imagesApi.uploadImage(imageFormData).then((response) => {
          console.log(response);
          this.question.imageCover = response;
          this.createquestionValidation();
        });
      } else {
        delete this.question.imageCover;
        this.createquestionValidation();
      }
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name);
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs["my-modal"].toggle("#toggle-btn");
      });
    },
  },
};
</script>
